export default __webpack_public_path__ + "static/media/pass.adf25e7e.png";